import TransactionResult from '../../../../../../Result';
import { ExternalRedirectProps } from './props';
import styles from './styles.module.scss';

/**
 * ExternalRedirect Component
 * This component is responsible for rendering the transaction result for an external redirect deposit.
 *
 * @param {ExternalRedirectProps} props - The properties for the component.
 * @param {object} props.deposit - The deposit object containing details of the transaction.
 *
 * @returns {JSX.Element} The rendered component displaying the transaction result.
 *
 * @example
 * // Usage example:
 * const deposit = { status: { id: '1' }, ...otherProps };
 * <ExternalRedirect deposit={deposit} />
 */
export default function ExternalRedirect({ deposit }: ExternalRedirectProps) {
  return (
    <div className={styles.container}>
      <TransactionResult transaction={deposit} />
    </div>
  );
}
